import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext, useModel } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import StatementPreferencePage, { getDefaultPageData } from "components/pages/StatementPreferencePage";
import Classes from "model";
import { useEffect } from "react";

export default function CaptureEStatementsEnrollElectronicSelected(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);
    const { branding } = useModel();
    const { accounts, deliveryOptions } = getDefaultPageData(branding);
    const deliveryOptionsHasPaper = deliveryOptions.filter(item => item.label === "Paper").length > 0;
    const deliveryOptionsPaperIndex = deliveryOptions.findIndex(item => item.label === "Paper");

    // Select the next item in the first account "select". 
    // If the branding option includes "Paper", then is a special case where "Paper" is used as a point of reference.
    const _accounts = accounts.reduce((acc, item, index) => {
        if(index === 0) {
            if(deliveryOptionsHasPaper) {
                if(deliveryOptionsPaperIndex > 0) {
                    item.statementPreference = deliveryOptions[0].label;
                } else {
                    item.statementPreference = deliveryOptions[1].label;
                }
            } else {
                item.statementPreference = deliveryOptions[1].label;
            }
        }
        
        acc.push(item);
        return acc;
    }, []);

    const data = BCMSStateManagerCRUD.init(getDefaultPageData(branding))
    .update([ "accounts" ], _accounts)
    .submit();

    useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    });

    return <StatementPreferencePage data={ data } />
}